import React, { useState, useEffect } from "react";
import { Box, Button, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useIsMobile from "../../hooks/useIsMobile";
import { trackSignUpClick } from "../../utils/analytics";

const FloatingCTA = () => {
  const isMobile = useIsMobile();
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isClosed) {
        setIsVisible(true);
      }
    }, 30000);

    const handleScroll = () => {
      const scrollPercentage =
        (window.scrollY /
          (document.documentElement.scrollHeight - window.innerHeight)) *
        100;
      if (scrollPercentage > 70 && !isClosed) {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isClosed]);

  const handleClose = () => {
    setIsVisible(false);
    setIsClosed(true);
    localStorage.setItem("floatingCTAClosed", "true");
  };

  const handleSignUpClick = () => {
    trackSignUpClick("floating_cta");
    window.location.href = "/cadastro";
  };

  useEffect(() => {
    const wasClosed = localStorage.getItem("floatingCTAClosed");
    if (wasClosed) {
      setIsClosed(true);
    }
  }, []);

  if (!isVisible || isClosed) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: isMobile ? "20px" : "30px",
        right: isMobile ? "20px" : "30px",
        zIndex: 1000,
        animation: "slideIn 0.5s ease-out",
        "@keyframes slideIn": {
          "0%": {
            transform: "translateX(100%)",
            opacity: 0,
          },
          "100%": {
            transform: "translateX(0)",
            opacity: 1,
          },
        },
      }}
    >
      <Box
        sx={{
          background: "linear-gradient(135deg, #226FE2 0%, #0033FF 100%)",
          borderRadius: "20px",
          padding: isMobile ? "20px" : "25px",
          boxShadow: "0 8px 32px rgba(34, 111, 226, 0.3)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          maxWidth: isMobile ? "280px" : "320px",
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "#fff",
            opacity: 0.7,
            "&:hover": {
              opacity: 1,
            },
          }}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
        <Box sx={{ color: "#fff", textAlign: "center" }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: isMobile ? "18px" : "20px",
              marginBottom: "8px",
              fontFamily: "sans-serif",
            }}
          >
            🎯 Perdendo dinheiro?
          </Typography>

          <Typography
            sx={{
              fontSize: isMobile ? "14px" : "16px",
              opacity: 0.9,
              marginBottom: "20px",
              lineHeight: 1.4,
              fontFamily: "sans-serif",
            }}
          >
            Cada reserva perdida é dinheiro que sai do seu bolso. Automatize
            agora e recupere seu tempo!
          </Typography>

          <Button
            onClick={handleSignUpClick}
            variant="contained"
            sx={{
              background: "#fff",
              color: "#226FE2",
              padding: "12px 24px",
              borderRadius: "25px",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "none",
              width: "100%",
              boxShadow: "0 4px 14px rgba(255, 255, 255, 0.3)",
              "&:hover": {
                background: "#f5f5f5",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 20px rgba(255, 255, 255, 0.4)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Teste grátis por 7 dias
          </Button>

          <Typography
            sx={{
              fontSize: "12px",
              opacity: 0.7,
              marginTop: "10px",
              fontFamily: "sans-serif",
            }}
          >
            ⚡ Setup em 5 minutos
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FloatingCTA;
